var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("system-custom-notifications-step", {
    attrs: { overflow: true, sidebar: true },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c("h4", { staticClass: "custom-notification__heading" }, [
              _vm._v("Send Notification"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "send custom-notification__container" }, [
              _vm.data.nexmo.selected
                ? _c("div", [
                    _c("h2", [_vm._v("SMS Options")]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "Are you sure you want to send your message to " +
                          _vm._s(_vm.selectedStars.length) +
                          " talent at $0.07 per " +
                          _vm._s(_vm.$starLabel) +
                          "?"
                      ),
                    ]),
                    _vm._v(" "),
                    _c("textarea", {
                      ref: "nexmo_message",
                      staticClass: "form-control",
                      attrs: {
                        name: "text",
                        rows: "2",
                        maxlength: "160",
                        placeholder: _vm.data.nexmo.text,
                        disabled: true,
                      },
                    }),
                    _vm._v(" "),
                    _c("small", [
                      _vm._v(
                        _vm._s(_vm.data.nexmo.text.length) +
                          " of 160 characters"
                      ),
                    ]),
                    _c("br"),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.data.onesignal.selected || _vm.data.email.selected
                ? _c(
                    "div",
                    [
                      _c("h2", [_vm._v("Notification Options")]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          "Are you sure you want to send your message to " +
                            _vm._s(_vm.selectedStars.length) +
                            " " +
                            _vm._s(_vm.$starLabelPlural) +
                            "?"
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.data.onesignal.selected &&
                      (!_vm.data.email.selected ||
                        (_vm.data.email.selected &&
                          !_vm.data.email.subject_same))
                        ? _c("h3", [
                            _vm._v("\n          Push Notification Heading"),
                          ])
                        : _vm.data.onesignal.selected
                        ? _c("h3", [
                            _vm._v("Push Notification and Email Heading"),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.data.onesignal.selected
                        ? _c("textarea", {
                            ref: "onesignal_heading",
                            staticClass: "form-control",
                            attrs: {
                              name: "text",
                              rows: "2",
                              placeholder: _vm.data.settings.heading,
                              disabled: true,
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _vm.data.onesignal.selected &&
                      (!_vm.data.email.selected ||
                        (_vm.data.email.selected &&
                          !_vm.data.email.content_same))
                        ? _c("h3", [
                            _vm._v("\n          Push Notification Content"),
                          ])
                        : _vm.data.onesignal.selected
                        ? _c("h3", [
                            _vm._v("Push Notification and Email Content"),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.data.onesignal.selected
                        ? _c("textarea", {
                            ref: "onesignal_heading",
                            staticClass: "form-control",
                            attrs: {
                              name: "text",
                              rows: "2",
                              placeholder: _vm.data.settings.content,
                              disabled: true,
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _vm.data.email.selected && !_vm.data.email.subject_same
                        ? _c("h3", [_vm._v("Email Heading")])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.data.email.selected && !_vm.data.email.subject_same
                        ? _c("textarea", {
                            ref: "onesignal_heading",
                            staticClass: "form-control",
                            attrs: {
                              name: "text",
                              rows: "2",
                              placeholder: _vm.data.email.heading,
                              disabled: true,
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _vm.data.email.selected && !_vm.data.email.content_same
                        ? _c("h3", [_vm._v("Email Content")])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.data.email.selected && !_vm.data.email.content_same
                        ? _c("redactor", {
                            ref: "email_content",
                            staticClass: "form-control",
                            attrs: {
                              type: "text",
                              name: "email_content",
                              rows: "2",
                              disabled: true,
                            },
                            model: {
                              value: _vm.data.email.content,
                              callback: function ($$v) {
                                _vm.$set(_vm.data.email, "content", $$v)
                              },
                              expression: "data.email.content",
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _vm.data.settings.link_notification
                        ? _c("div", [
                            _c("h3", [_vm._v("Push Notification Link")]),
                            _vm._v(" "),
                            _c("textarea", {
                              ref: "onesignal_heading",
                              staticClass: "form-control",
                              attrs: {
                                name: "text",
                                rows: "2",
                                placeholder: _vm.data.settings.link,
                                disabled: true,
                              },
                            }),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.data.settings.package_notification
                        ? _c("div", [
                            _c("h3", [_vm._v("Selected Package")]),
                            _vm._v(" "),
                            _c("input", {
                              staticClass:
                                "selectize selectize-single form-control",
                              attrs: {
                                name: "tag_type",
                                placeholder: _vm.selectedPackage,
                                disabled: true,
                              },
                            }),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.data.settings.response_notification
                        ? _c(
                            "div",
                            [
                              _c("h3", [_vm._v("Available Responses")]),
                              _vm._v(" "),
                              _vm._l(
                                _vm.data.settings.button_items,
                                function (suboption, index) {
                                  return _c(
                                    "ul",
                                    { key: index, staticClass: "item-detail" },
                                    [
                                      _c("div", { staticClass: "row" }, [
                                        _c("div", { staticClass: "col-sm-4" }, [
                                          _c("input", {
                                            ref: "onesignal_response",
                                            refInFor: true,
                                            staticClass: "form-control",
                                            attrs: {
                                              name: "text",
                                              placeholder:
                                                _vm.data.settings.button_items[
                                                  index
                                                ].button_text,
                                              disabled: true,
                                            },
                                          }),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-sm-8" },
                                          [
                                            _c("tags", {
                                              attrs: {
                                                type: "theme",
                                                disabled: true,
                                              },
                                              model: {
                                                value:
                                                  _vm.data.settings
                                                    .button_items[index].tags,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.data.settings
                                                      .button_items[index],
                                                    "tags",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "data.settings.button_items[index].tags",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("br"),
                                    ]
                                  )
                                }
                              ),
                              _vm._v(" "),
                              _c("div", { attrs: { id: "bottom" } }),
                            ],
                            2
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "sidebar",
        fn: function () {
          return [
            _c("h2", [
              _vm._v(
                "Selected " +
                  _vm._s(_vm._f("sentenceCase")(_vm.$starLabelPlural))
              ),
            ]),
            _vm._v(" "),
            _c(
              "ul",
              _vm._l(_vm.selectedStars, function (talent) {
                return _c("li", { key: talent.id }, [
                  _c("button", [
                    _vm._v("\n          " + _vm._s(talent.name) + " "),
                    _c("i", {
                      staticClass: "fa fa-times",
                      on: {
                        click: function ($event) {
                          return _vm.handleRemoveTalentCallback(talent)
                        },
                      },
                    }),
                  ]),
                ])
              }),
              0
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "cta",
        fn: function () {
          return [
            _c(
              "button",
              {
                staticClass: "btn btn-default",
                attrs: { type: "button" },
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                  },
                  click: _vm.lastPage,
                },
              },
              [
                _c("i", { staticClass: "fa fa-chevron-left" }),
                _vm._v(" Previous"),
              ]
            ),
            _vm._v(" "),
            _c(
              "ladda-button",
              {
                staticClass: "btn btn-primary pull-right",
                attrs: { click: _vm.handleSendNotificationCallback },
              },
              [
                _vm._v("\n      Yes, Send "),
                _c("i", { staticClass: "fa fa-send" }),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }